import React from "react";
import '../../pagesCSS/Projects.css';

const RSSReader = () => {
  return (
    <div className='projectInfo'>
      <h2 className='projectTitle'>RSS Reader (Jan 2021 - Feb 2021)</h2>
      <ul className='projectBody'>
        <li>UN news feed with multiple categories</li>
        <li>Displays current events as they occur</li>
        <li>Simple and easy to use interface</li>
        <li>Practice building layouts, activities, and activity adapters</li>
        <li>Working with Intents</li>
        <li>Technologies Used:</li>
          <ul>
            <li>Kotlin</li>
          </ul>
      </ul>
    </div>
  )
}

export default RSSReader;